import React from "react";
import { useLang } from "@/i18n";
import { useContent } from "@/content";
import { Reveal, Eyebrow } from "@/components/Reveal";
import { Star } from "@/components/Monogram";
import { waHref } from "@/components/Nav";

export default function Wedding() {
  const { lang, t } = useLang();
  const { content } = useContent();
  const w = content && content.wedding;
  if (!w) return null;
  const contacts = (content && content.contacts) || { whatsapp: "393751163111" };

  return (
    <section className="relative border-t hairline py-24 sm:py-28" data-testid="wedding-section">
      <div className="mx-auto max-w-4xl px-6 text-center sm:px-10">
        <Reveal>
          <div className="flex items-center justify-center gap-3">
            <Star size={9} fill="#C5A059" />
            <Eyebrow>Wedding Day</Eyebrow>
            <Star size={9} fill="#C5A059" />
          </div>
        </Reveal>
        <Reveal delay={0.08}>
          <h2 className="font-display mt-6 text-3xl font-light leading-tight text-[#FAF9F6] sm:text-4xl lg:text-5xl" data-testid="wedding-title">
            {t(w.title)}
          </h2>
        </Reveal>
        <Reveal delay={0.14}>
          <p className="mx-auto mt-7 max-w-2xl text-sm font-light leading-relaxed text-[#A1A1AA] sm:text-base" data-testid="wedding-text">
            {t(w.text)}
          </p>
        </Reveal>
        <Reveal delay={0.2}>
          <a
            href={waHref(
              {
                whatsapp: contacts.whatsapp,
                whatsapp_msg: {
                  it: "Sono interessato/a al servizio Wedding Day / Wedding Transfer, posso avere informazioni?",
                  en: "Hello, I am interested in the Wedding Day / Wedding Transfer service, may I have some information?",
                },
              },
              lang
            )}
            target="_blank"
            rel="noopener noreferrer"
            className="btn-gold-bright mt-10"
            data-testid="wedding-cta"
          >
            {t(w.cta)}
          </a>
        </Reveal>
        <Reveal delay={0.26}>
          <p className="mt-6 text-[11px] font-light tracking-[0.2em] text-[#FAF9F6]/40 uppercase">
            {lang === "en" ? "Dedicated service · Dolomites and Trentino" : "Servizio dedicato · Dolomiti e Trentino"}
          </p>
        </Reveal>
      </div>
    </section>
  );
}
